@if (open()) {
  <div
    class="backdrop"
    (click)="hide()"
  ></div>
  <div
    class="ao-menu-overlay"
    [ngClass]="{ large: large() }"
  >
    <div
      class="ao-menu-overlay-details"
      [attr.data-testid]="'menu-overlay-details'"
    >
      <div class="ao-menu-overlay-details-header">
        <ng-content
          select="[header]"
          style="display: inline"
        >
        </ng-content>
      </div>
      <div class="ao-menu-overlay-details-animation">
        <bnd-button
          (click)="hide()"
          [attr.data-testid]="'menu-overlay-details-close'"
          mode="ghost"
          shape="square"
          size="sm"
        >
          <i class="pi pi-times text-red-500"></i>
        </bnd-button>
      </div>
      <hr size="1" />
      <ng-content select="[body]"> </ng-content>
    </div>
  </div>
}
